import { getClassLevel } from "../shared/getClassLevel";
import { evaluateDivineStrike } from "./divineStrike";

const clericAdapter = Object.freeze({
  id: "cleric",
  getClassLevel: (character) => getClassLevel(character, "cleric"),
  evaluateOnHit: (context) => [evaluateDivineStrike({ context })],
});

export default clericAdapter;
